import React, { useState } from 'react';
import Icon from '@/components/AppIcon';
import Button from '@/components/ui/Button';
import Input from '@/components/ui/Input';

const JobRolesStep = ({ formData, onChange, errors }) => {
const [customRole, setCustomRole] = useState('');

const suggestedRoles = [
"Software Engineer",
"Frontend Developer",
"Backend Developer",
"Full Stack Developer",
"DevOps Engineer",
"Data Scientist",
"Product Manager",
"UX/UI Designer",
"Business Analyst",
"Project Manager",
"Marketing Manager",
"Sales Executive",
"HR Manager",
"Financial Analyst",
"Content Writer"
];

const selectedRoles = formData?.jobRoles || [];

const handleRoleToggle = (role) => {
const updatedRoles = selectedRoles?.includes(role)
? selectedRoles?.filter(r => r !== role)
: [...selectedRoles, role];

onChange({ ...formData, jobRoles: updatedRoles });
};

const handleAddCustomRole = () => {
if (customRole?.trim() && !selectedRoles?.includes(customRole?.trim())) {
onChange({ 
...formData, 
jobRoles: [...selectedRoles, customRole?.trim()] 
});
setCustomRole('');
}
};

const handleRemoveRole = (role) => {
onChange({ 
...formData, 
jobRoles: selectedRoles?.filter(r => r !== role) 
});
};

return (
<div className="space-y-6">
<div className="step-form-section">
<h2 className="step-form-section-title">Target Job Roles</h2>
<p className="text-sm text-muted-foreground mb-6">
Select or add the job roles you're interested in. You can choose multiple roles.
</p>

{selectedRoles?.length > 0 && (
<div className="mb-6">
<label className="block text-sm font-medium text-foreground mb-3">
Selected Roles ({selectedRoles?.length})
</label>
<div className="flex flex-wrap gap-2">
{selectedRoles?.map((role) => (
<div
key={role}
className="inline-flex items-center gap-2 px-4 py-2 bg-primary text-primary-foreground rounded-lg text-sm font-medium"
>
<span>{role}</span>
<button
type="button"
onClick={() => handleRemoveRole(role)}
className="hover:bg-primary-foreground/20 rounded-full p-0.5 transition-colors"
aria-label={`Remove ${role}`}
>
<Icon name="X" size={14} />
</button>
</div>
))}
</div>
</div>
)}

<div className="mb-6">
<label className="block text-sm font-medium text-foreground mb-3">
Suggested Roles
</label>
<div className="tag-selection-grid">
{suggestedRoles?.map((role) => {
const isSelected = selectedRoles?.includes(role);
return (
<button
key={role}
type="button"
onClick={() => handleRoleToggle(role)}
className={`tag-option ${isSelected ? 'selected' : ''}`}
>
{role}
</button>
);
})}
</div>
</div>

<div className="mt-6">
<label className="block text-sm font-medium text-foreground mb-3">
Add Custom Role
</label>
<div className="flex gap-3">
<Input
type="text"
placeholder="Enter job role (e.g., Cloud Architect)"
value={customRole}
onChange={(e) => setCustomRole(e?.target?.value)}
onKeyPress={(e) => {
if (e?.key === 'Enter') {
e?.preventDefault();
handleAddCustomRole();
}
}}
className="flex-1"
/>
<Button
variant="outline"
onClick={handleAddCustomRole}
disabled={!customRole?.trim()}
iconName="Plus"
iconPosition="left"
>
Add
</Button>
</div>
</div>

{errors?.jobRoles && (
<p className="text-sm text-error mt-4">{errors?.jobRoles}</p>
)}

<div className="mt-6 p-4 bg-amber-50 dark:bg-amber-950/20 rounded-lg border border-amber-200 dark:border-amber-800">
<div className="flex items-start gap-3">
<Icon name="Target" size={20} className="text-amber-600 dark:text-amber-400 flex-shrink-0 mt-0.5" />
<div className="text-sm text-amber-900 dark:text-amber-100">
<p className="font-medium mb-1">Recommendation:</p>
<p className="text-amber-800 dark:text-amber-200">
Select 3-5 related job roles to maximize your application success rate while maintaining focus.
</p>
</div>
</div>
</div>
</div>
</div>
);
};

export default JobRolesStep;